import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 5px;
`;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/styles.js